import { action, observable, makeObservable } from 'mobx';

import agent from '../agent';

class PermissionGroupStore {
    constructor() {
        makeObservable(this, {
            groups: observable,
            pages: observable,
            total: observable,
            loading: observable,
            getGroups: action,
            getAssignableUsers: action,
            saveGroup: action,
            saveMembers: action,
            applyGroup: action,
            removeGroup: action,
        });
    }

    groups = [];
    pages = 1;
    total = 0;
    loading = false;

    /** The server filters and pages: pass { page, pagesize, name, user_type }. */
    getGroups(params = {}) {
        this.loading = true;
        return agent.PermissionGroups.getGroups(params)
            .then(action(response => {
                this.groups = response.groups || [];
                this.pages = response.pages || 1;
                this.total = response.total || 0;
                this.loading = false;
                return { groups: this.groups, pages: this.pages, total: this.total };
            }))
            .catch(action(err => {
                this.loading = false;
                throw err;
            }));
    }

    getAssignableUsers(user_type) {
        return agent.PermissionGroups.getAssignableUsers({ user_type })
            .then(action(response => response.users || []))
            .catch(action(err => { throw err; }));
    }

    /**
     * Saves the group definition only - name, target role, permissions and
     * onboarding fields. The employee list is saved separately by saveMembers, so
     * an admin can change permissions without touching who is in the group.
     */
    saveGroup(group) {
        const payload = {
            name: group.name,
            description: group.description,
            user_type: group.user_type,
            permissions: group.permissions,
            profile_settings: group.profile_settings || {},
        };
        const request = group.id && group.id !== 'new'
            ? agent.PermissionGroups.updateGroup(group.id, payload)
            : agent.PermissionGroups.createGroup(payload);
        return request
            .then(action(response => response))
            .catch(action(err => { throw err; }));
    }

    /** Saves the employee list on its own; the server applies the group to whoever is added. */
    saveMembers(id, memberIds) {
        return agent.PermissionGroups.saveGroupMembers(id, { members: memberIds })
            .then(action(response => response))
            .catch(action(err => { throw err; }));
    }

    applyGroup(id, user_ids) {
        return agent.PermissionGroups.applyGroup(id, user_ids ? { user_ids } : {})
            .then(action(response => response))
            .catch(action(err => { throw err; }));
    }

    removeGroup(id) {
        return agent.PermissionGroups.removeGroup(id)
            .then(action(response => response))
            .catch(action(err => { throw err; }));
    }
}

const _PermissionGroupStore = new PermissionGroupStore();
export default _PermissionGroupStore;
